import React from 'react';
import {
  withStyles,
} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { Pie } from 'react-chartjs-2';
import 'chartjs-plugin-datalabels';

import Footer from '../BedsAvailabilityCardFooter/BedsAvailabilityCardFooter';
import Moment from 'react-moment';
import styles from './BedsAvailabilityCardStyle';

const BedsAvailabilityCard = ({ classes, onInternmentRequest,occupiedBeds, freeBeds,noOfPatients, allBeds,overBeds, dateLastUpdate }) => {
  
  const chartData = {
    labels: ['Ocupate', 'Libere','Suprapopulare'],
    datasets: [{
      data: [occupiedBeds,freeBeds, overBeds],
      backgroundColor: ['#029AB1', '#FFFF00', '#ff0000'],
      hoverBackgroundColor: '#00d5dd',
    }],
  };
  const chartOptions = {
    cutoutPercentage: 60,
    circumference: Math.PI + (Math.PI/27*overBeds),
    rotation: -Math.PI,
    plugins: {
        datalabels: {
          backgroundColor: function (context) {
            return context.dataset.backgroundColor;
          },
          borderColor: 'white',
          borderRadius: 25,
          borderWidth: 2,
          color: 'black',
          display: function (context) {
            var dataset = context.dataset;
            var count = dataset.data.length;
            var value = dataset.data[context.dataIndex];
            return value > count * 1.5;
          },
          font: {
            weight: 'bold',
            size: '16'
          },
          formatter: Math.round
        }
    }
  };

  
  return (
    
    <Paper className={classes.bedsAvailabilityRoot}>
      <Typography className={classes.title}>Disponibilitate Paturi</Typography>
      <div className={classes.allBedsCount}>
        <Typography  variant="display3">{allBeds}</Typography>
        <Typography variant="subtitle1">Paturi Total</Typography>
        <Typography  variant="display3">{noOfPatients}</Typography>
        <Typography variant="subtitle1">Numar Pacienti</Typography>
      </div>
       <div className={classes.chartWrapper}>
        <Pie data={chartData} options={chartOptions} />
      </div> 
      <div className={classes.freeBedsCount}>
        <Typography className={classes.freeBedsCountNumber} variant="display3">{freeBeds}</Typography>
        <Typography variant="subtitle1">Paturi Libere</Typography>
        <Typography className={classes.overBedsCountNumber} variant="display3">{overBeds}</Typography>
        <Typography variant="subtitle1">Peste capacitate</Typography>
      </div>

      <Footer className={classes.footer} label="Actualizat:" value={<Moment fromNow >{dateLastUpdate}</Moment>} onInternmentRequest={onInternmentRequest}/>
    </Paper>
  );
};

export default withStyles(styles)(BedsAvailabilityCard);
